export enum InputMaxLength {
  medium = 1000,
  large = 2000,
  larger = 3000,
  extraLarge = 4000,
}
